import { useEffect, useState } from "react";
import { Reveal } from "./Reveal";

const LAUNCH_DATE = new Date("2027-01-01T09:00:00");

const pad = (n) => String(n).padStart(2, "0");

const useCountdown = () => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const diff = Math.max(0, LAUNCH_DATE.getTime() - now);
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    seconds: Math.floor((diff % 60000) / 1000),
  };
};

export const LaunchCountdown = () => {
  const { days, hours, minutes, seconds } = useCountdown();
  const units = [
    { label: "Days", value: days },
    { label: "Hours", value: pad(hours) },
    { label: "Minutes", value: pad(minutes) },
    { label: "Seconds", value: pad(seconds) },
  ];

  return (
    <section className="border-t border-[#C4A36A]/30 bg-[#F7F3EA]" data-testid="launch-countdown-section">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <Reveal className="text-center">
          <p className="mb-6 text-xs font-bold uppercase tracking-[0.25em] text-[#9A7428]" data-testid="countdown-overline">
            The doors open
          </p>
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-[#7A5A14] md:text-6xl" data-testid="countdown-headline">
            January 1.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#5C4632] md:text-lg">
            The first city opens at nine. Waitlist members arrive with seven days of membership on us. The cities with the most interest open first.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-14 flex items-start justify-center divide-x divide-[#C4A36A]/30 text-[#7A5A14]" data-testid="countdown-timer">
            {units.map((u) => (
              <div key={u.label} className="px-5 text-center md:px-12" data-testid={`countdown-${u.label.toLowerCase()}`}>
                <p className="font-serif text-5xl tabular-nums tracking-tight md:text-7xl">{u.value}</p>
                <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.25em] text-[#8A6840]">{u.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
